
import React from 'react';
import styles from './AuditionRoleCard.module.css';

function AuditionRoleCard({ role, onApply, appliedRoleIds, onDetail, isExpired }) {
  const hasApplied = appliedRoleIds?.has(String(role.id)) ?? false;
  const isDisabled = hasApplied || isExpired;

  return (
    <div className={styles.card}>
      {/* 역할명 + 출연료 + 태그 */}
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <strong className={styles.name}>{role.name}</strong>
          {role.payment && (
            <span className={styles.payment}>{role.payment}</span>
          )}
        </div>

        {/* 성별 + 나이대 태그 */}
        <div className={styles.tags}>
          {role.roleType && (
            <span className={styles.tag}>{role.roleType}</span>
          )}
          {role.gender && role.gender !== '무관' && (
            <span className={styles.tag}>{role.gender}</span>
          )}
          {role.ageRange && role.ageRange !== '제한 없음' && (
            <span className={styles.tag}>{role.ageRange}</span>
          )}
        </div>
      </div>

      {/* 역할 설명 (3줄 클램프) */}
      {role.description && (
        <p className={styles.description}>{role.description}</p>
      )}

      {role.shootingPeriod && role.shootingPeriod !== '추후 공지' && (
        <div className={styles.shootingInfo}>
          <span className={styles.shootingLabel}>촬영일</span>
          <span className={styles.shootingValue}>{role.shootingPeriod}</span>
        </div>
      )}

      {/* 상세보기 + 지원하기 */}
      <div className={styles.buttonRow}>
        <button
          className={styles.detailButton}
          onClick={() => onDetail?.(role)}
        >
          상세보기
        </button>
        <button
          className={`${styles.applyButton} ${isDisabled ? styles.appliedButton : ''}`}
          onClick={() => !isDisabled && onApply?.(role.id)}
          disabled={isDisabled}
        >
          {hasApplied ? '지원 완료' : isExpired ? '지원 마감' : '해당 배역 지원하기'}
        </button>
      </div>
    </div>
  );
}

export default AuditionRoleCard;
